import { uniq } from 'lodash'
import { CellSelection } from './CellSelection'
import { TableMap } from './TableMap'
import { getTableMapFromSelection } from 'common/Prose/Plugins/tableSelection/tableSelectionUtils'
import { NodeSelection } from 'prosemirror-state'
import { isTableSelection } from '.'

export type Rect = {
  rows: number[]
  cols: number[]
  top: number
  bottom: number
  left: number
  right: number
  height: number
  width: number
  selectedCoords: [number, number][]
  tableMap: TableMap
}

export const selectedRect = (selection: CellSelection | NodeSelection): Rect => {
  if (!(selection instanceof CellSelection || isTableSelection(selection))) {
    throw new Error('Selection is not table-like')
  }

  let tableMap: TableMap
  let selectedCoords: [number, number][]
  if (selection instanceof CellSelection) {
    tableMap = getTableMapFromSelection(selection)
    selectedCoords = selection.$includedCells.map((cell) => tableMap.getCoordListOfPos(cell.pos)).flat(1)
  } else {
    tableMap = new TableMap({ posBeforeTable: selection.from, node: selection.node })
    selectedCoords = tableMap.getAllKnownCoords()
  }

  const includedRows = uniq(selectedCoords.map((coord) => coord[0]))
  const includedCols = uniq(selectedCoords.map((coord) => coord[1]))
  const height = includedRows.length
  const width = includedCols.length

  return {
    rows: includedRows,
    cols: includedCols,
    top: Math.min(...includedRows),
    bottom: Math.max(...includedRows),
    left: Math.min(...includedCols),
    right: Math.max(...includedCols),
    height,
    width,
    selectedCoords,
    tableMap,
  }
}
